import { getPreferencesByWorkspace } from '../utilities/getPreferencesByWorkspace';
export function setWorkspace(draft, action) {
    const workspaceKey = action.payload.workspace;
    if (!draft.workspaces[workspaceKey]) {
        draft.workspaces[workspaceKey] = getPreferencesByWorkspace(workspaceKey);
    }
    draft.workspace.current = workspaceKey;
}
